import React, { FC, useEffect, useState } from "react";
import CreatableSelect, { components } from "react-select";
import { customStyles } from "../../models/SelectCustomStyles";

interface InputTagsGroupProps {
  clear: boolean;
  isEdit: boolean;
  onValue: (value: Option[]) => void;
  clearInput?: any;
  valueInput?: any;
  className?: string;
}

type Option = {
  label: string;
  value: string;
};

const CustomInput = (props: any) => {
  const { selectProps, value } = props;

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();

    const text = e.clipboardData.getData("text");
    const values = text
      .split(/[\t\n,;]+/)
      .map((v) => v.trim())
      .filter((v) => v);

    if (selectProps.handlePasteValues) {
      selectProps.handlePasteValues(values);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const inputValue = props.selectProps.inputValue?.trim();

    if (!inputValue) return;

    if (["Enter", "Tab", ",", ";"].includes(e.key)) {
      e.preventDefault();

      const exists = props.selectProps.value?.some(
        (item: Option) => item.value === inputValue
      );

      if (!exists) {
        const newOption = { label: inputValue, value: inputValue };
        props.selectProps.handlePasteValues([inputValue]);
      }

      props.selectProps.setInputValue("");
    }
  };

  return (
    <components.Input
      {...props}
      onPaste={handlePaste}
      onKeyDown={handleKeyDown}
    />
  );
};

const InputTagsGroup: FC<InputTagsGroupProps> = ({
  onValue,
  isEdit,
  clear,
  clearInput,
  valueInput,
  className,
}) => {
  const [value, setValue] = useState<Option[]>([]);
  const [inputValue, setInputValue] = useState("");
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    onValue(value);
  }, [value]);

  useEffect(() => {
    if (!initialized && valueInput && valueInput.length > 0) {
      const mapped = valueInput
        //.filter((item: any) => item?.label && item?.value)
        .map((item: any) => ({
          label: item?.label,
          value: item?.value,
        }));

      setValue((prev) => {
        const merged = [...prev];
        mapped.forEach((x: any) => {
          if (!merged.some((v) => v.value === x.value)) {
            merged.push(x);
          }
        });
        return merged;
      });

      setInitialized(true);
    }
  }, [valueInput, initialized]);

  useEffect(() => {
    if (clear) {
      setValue([]);
      setInputValue("");
      onValue([]);
      setInputValue("");
      clearInput(true);
    }
  }, [clear]);

  const handlePasteValues = (items: string[]) => {
    const newItems = items
      .filter((item) => !value.some((v) => v.value === item))
      .map((item) => ({ label: item, value: item }));
    setValue((prev) => [...prev, ...newItems]);
  };

  return (
    <CreatableSelect
      isMulti
      isClearable
      menuIsOpen={false}
      components={{ Input: CustomInput }}
      defaultValue={valueInput}
      value={value}
      onChange={(val) => setValue(val as Option[])}
      inputValue={inputValue}
      onInputChange={(val) => setInputValue(val)}
      placeholder="Ex: CP"
      // @ts-ignore: prop customizada para Input
      handlePasteValues={handlePasteValues}
      setInputValue={setInputValue}
      styles={customStyles}
      className={`form-control p-0 ${className}`}
      isDisabled={isEdit}
    />
  );
};

export default InputTagsGroup;
